import gql from "graphql-tag";

export const createTask = gql`
  mutation CreateTask($data: TaskCreateInput!){
    createTask(data: $data){
      id
    }
  }
`;